export default {
	webSocketInit: webSocketInit,
	webSocketConnect: webSocketConnect,
	webSocketOnClose: webSocketOnClose,
	webSocketOnError: webSocketOnError
};

var data = {
	ws: null
}

function webSocketInit(url) {   //初始化，并尝试连接
	var ws = null
	if ("WebSocket" in window) {
		// console.log("浏览器支持 WebSocket");
		ws = new WebSocket(url)
	} else {
		// console.log("浏览器不支持 WebSocket")
	}
	return ws
}

function webSocketConnect(ws) {   //建立连接后调用onopen
	ws.onopen = function () {
		// console.log('建立连接成功！')
		webSocketOnError(ws);
		webSocketOnClose(ws);
		// setInterval(() => {
		// 	ws.send('ping')
		// 	console.log('ping...')
		// }, 5000);
	}
}

// function webSocketOnMessage(ws) {   //接收数据
// 	var received_msg = null
// 	ws.onmessage = function (evt) {
// 		received_msg = evt.data
// 		console.log('接收到数据:', received_msg)
		
// 	}
// 	// msg = received_msg;
// 	// return received_msg;
// }

function webSocketOnClose(ws) {     //监听正常关闭websocket
	ws.onclose = function () {
		// console.log("WebSocket 连接已关闭...")
	}
	// console.log('监听onclose')
}

function webSocketOnError(ws) {     //监听连接过程中出现的错误
	ws.onerror = function (evt) {
		// console.log("WebSocket 发生错误:" + evt)
	}
	// console.log('监听onerror')
}



// WEBPACK FOOTER //
// ./src/components/common/webSocket.js